import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { operationStatus } from "../../components/ActionStatus";
import ToggleSwitch from "../../components/ToggleSwitch";

/**
 * Demo component for ToggleSwitch
 * Shows different states and configurations of the ToggleSwitch component
 */
const ToggleSwitchDemo = () => {
  const [fetchStatus, setFetchStatus] = useState(operationStatus.IDLE);

  // Mock update function that simulates an API call
  const mockUpdateFunction = (newValue) => {
    return new Promise((resolve) => {
      // Simulate API delay
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Box display="flex" alignItems="center" gap={2}>
        <ToggleSwitch
          defaultValue={true}
          updateFunction={mockUpdateFunction}
          setFetchStatus={setFetchStatus}
        />
        <Typography variant="body2">
          Active Toggle (API Status: {fetchStatus})
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" gap={2}>
        <ToggleSwitch
          defaultValue={false}
          updateFunction={mockUpdateFunction}
          setFetchStatus={setFetchStatus}
        />
        <Typography variant="body2">Inactive Toggle</Typography>
      </Box>

      <Box display="flex" alignItems="center" gap={2}>
        <ToggleSwitch
          defaultValue={true}
          updateFunction={mockUpdateFunction}
          setFetchStatus={setFetchStatus}
          isPermanentlyDisabled={true}
        />
        <Typography variant="body2">Disabled Toggle</Typography>
      </Box>
    </Box>
  );
};

export default ToggleSwitchDemo;
